export const SELECTED_COUNTRY_USA = 'US';
export const SELECTED_COUNTRY_UK = 'UK';
